export default __webpack_public_path__ + "e1e3bd763d47f0b756ce8a94c7b9aff2.png";